var map = {
	"./Accordion.js": 361,
	"./Cookiebar.js": 7847,
	"./Countdown.js": 5516,
	"./Depth.js": 4855,
	"./Form.js": 9264,
	"./Header.js": 7181,
	"./HeaderGrensesprenger.js": 5048,
	"./InlineVideo.js": 76,
	"./InlineVimeoEmbed.js": 1330,
	"./ModalTrigger.js": 8303,
	"./Register.js": 4242,
	"./SectionNav.js": 5031,
	"./TaskTeaser.js": 5809,
	"./Tasks.js": 8476,
	"./UploadForm.js": 7229,
	"./VideoEmbed.js": 9451,
	"./VideoModalTrigger.js": 6828,
	"components/Accordion.js": 361,
	"components/Cookiebar.js": 7847,
	"components/Countdown.js": 5516,
	"components/Depth.js": 4855,
	"components/Form.js": 9264,
	"components/Header.js": 7181,
	"components/HeaderGrensesprenger.js": 5048,
	"components/InlineVideo.js": 76,
	"components/InlineVimeoEmbed.js": 1330,
	"components/ModalTrigger.js": 8303,
	"components/Register.js": 4242,
	"components/SectionNav.js": 5031,
	"components/TaskTeaser.js": 5809,
	"components/Tasks.js": 8476,
	"components/UploadForm.js": 7229,
	"components/VideoEmbed.js": 9451,
	"components/VideoModalTrigger.js": 6828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2943;